import {
    GET_ALL_PRODUCT_RECEIPT_EXPORT,
    CREATE_NEW_PRODUCT_RECEIPT_EXPORT,
    UPDATE_SPECIFIC_PRODUCT_RECEIPT_EXPORT,
    GET_SPECIFIC_PRODUCT_RECEIPT_EXPORT,
    REMOVE_PRODUCT_RECEIPT_EXPORT
} from '@/redux/actions/types'

const INIT_STATE = {
    product_receipt_export_list: [],
    current_product_receipt_export: {},
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_PRODUCT_RECEIPT_EXPORT: {
            return {
                ...state,
                product_receipt_export_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page)
                }
            }
        }
        case CREATE_NEW_PRODUCT_RECEIPT_EXPORT: {
            return {
                ...state,
                product_receipt_export_list: [
                    action.payload,
                    ...state.product_receipt_export_list
                ],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_PRODUCT_RECEIPT_EXPORT: {
            return { ...state, current_product_receipt_export: action.payload }
        }
        case GET_SPECIFIC_PRODUCT_RECEIPT_EXPORT: {
            let index = state.product_receipt_export_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.product_receipt_export_list];
            temp[index] = action.payload;
            return { ...state, product_receipt_export_list: temp }
        }
        case REMOVE_PRODUCT_RECEIPT_EXPORT: {
            let temp = state.product_receipt_export_list.filter(role => {
                return action.payload.indexOf(role.id) < 0;
            });
            return { ...state, product_receipt_export_list: temp }
        }
        default:
            return { ...state }
    }

}
